var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"label":_vm.label,"hint":_vm.$t('inputs.chooseNumbers.hint'),"rows":"8","placeholder":_vm.$t('inputs.chooseNumbers.placeholder')},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }